//user service
export const API_SIGNUP = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/register/`;
export const API_LOGIN = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/login/`;
export const API_SEND_LOGIN_OTP = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/send-login-otp/`;
export const API_VERIFY_LOGIN_OTP = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/verify-login-otp/`;
export const API_USER_PROFILE = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/my-profile/`;
export const API_FORGOT_PASSWORD = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/forgot-password/`;
export const API_RESET_PASSWORD = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/reset-password/`;
export const API_GENERATE_GUEST_TOKEN = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/generate-guest-token/`;
export const API_ADD_BANK_DETAILS = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/host-bank-details/`;
export const API_GET_BANK_DETAILS_BY_ORG = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/host-bank-details/by-organization/`;

//host service
export const API_HOST_KEYWORD_BASED_SEARCH = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/properties/search-by-keyword/`;

//Guest services
export const API_POST_BOOKING = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/guests/bookings/`;

//host service - Property
export const API_GET_HOST_PROPERTY=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/properties/organizationID/org-properties`;
export const API_DELETE_HOST_PROPERTY=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/properties/propertyID/`;
export const API_CREATE_HOST_PROPERTY = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/properties/`;
export const API_UPDATE_HOST_PROPERTY=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/properties/propertyID/`;
export const API_GET_SINGLE_PROPERTY=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/properties/propertyID/`;


//host service - manage room and bed
export const API_GET_VIEW_BED=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/beds/`;
export const API_CREATE_BED=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/beds/`;
export const API_UPDATE_BED=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/beds/roomID/`;
export const API_CREATE_ROOM=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/rooms/`;
export const API_UPDATE_ROOM=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/rooms/roomID/`;
export const API_GET_VIEW_ROOM=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/rooms/`;

//host service - update room and bed duration
export const API_GET_LONGTERM_BEDS=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/pg_tenant/longterm/rooms/roomID/beds/`;

//host service - update room and bed duration
export const API_GET_ROOM_DURATION=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/roomavailability/by-property/propertyID/`;
export const API_UPDATE_ROOM_DURATION=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/roomavailability/roomID/`;
export const API_GET_BED_DURATION=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/bedavailability/by-property/propertyID/`;
export const API_UPDATE_BED_DURATION=`${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/bedavailability/bedID/`;

// Guest Check-in/Check-out
export const API_CHECK_IN = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/guests/guest-check/check-in/`;
export const API_GET_GUEST_OTP = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/users/my-otp/`;

// Payment service - Host Orders
export const API_GET_HOST_ORDERS_BY_PROPERTY = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/payments/properties/propertyID/orders/`;
export const API_GET_INVOICE_BY_BOOKING = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/payments/orders/bookingId/invoice/`;

// Tenant Agreement
export const API_PROPERTY_RULES = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/pg_tenant/property/propertyId/rules/`;
export const API_TENANT_AGREEMENT = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/pg_tenant/longterm/tenants/tenantId/agreement/`;

// PG Marketplace
export const API_PG_SALE_LISTINGS = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/pg_tenant/pg-sale/`;
export const API_PG_SALE_LISTING_DETAIL = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/pg_tenant/pg-sale/listingId/`;

// Landing page stats
export const API_LANDING_STATS = `${process.env.REACT_APP_USER_SERVICE_API_ENDPOINT}/api/hosts/stats/`;

// Admin
export const API_ADMIN_STATS = `/api/users/admin/stats/`;
export const API_ADMIN_USERS = `/api/users/admin/users/`;
export const API_ADMIN_USER_TOGGLE_ACTIVE = (pk: string) => `/api/users/admin/users/${pk}/toggle-active/`;
export const API_ADMIN_ORGANIZATIONS = `/api/users/admin/organizations/`;
export const API_ADMIN_VERIFICATIONS = `/api/users/admin/verifications/`;
export const API_ADMIN_VERIFICATION_REVIEW = (pk: string) => `/api/users/admin/verifications/${pk}/review/`;
